<template>
    <div class="mb-xl">
        <p class="h4 mb-sm">System summary - {{ configurationSize }}</p>
        <table class="table table--muted">
            <tbody>
                <tr>
                    <td>Total inverters</td>
                    <td>{{ totalInverters }}</td>
                </tr>
                <tr>
                    <td>Total panel</td>
                    <td>{{ totalPanels }}</td>
                </tr>
            </tbody>
        </table>
        <ConfigurationFlags :configuration="configuration" />
    </div>
</template>

<script>
import { round } from 'lodash';
import ConfigurationFlags from "@/jobs/new/ConfigurationFlags";
import { calculateSystemSize } from '@/../utils';

export default {
    components: {
        ConfigurationFlags,
    },

    props: {
        configuration: {
            type: Array,
            default: () => []
        },
    },

    computed: {
        configurationSize() {
            const size = calculateSystemSize(this.configuration);
            return round(size/1000, 2) + 'kW';
        },

        totalInverters() {
            return this.configuration.reduce((total, system) => {
                const { details: { inverterType }} = system.inverter;
                const qty = inverterType === 'micro' ? system.mppts[0].parallel : 1;
                return total + qty;
            }, 0);
        },

        totalPanels() {
            return this.configuration.reduce((total, system) => {
                const { details: { inverterType }} = system.inverter;
                let qty;

                if (inverterType === 'micro') {
                    qty = system.mppts[0].panel ? system.mppts[0].series : 0;
                } else {
                    qty = system.mppts.reduce((total, mppt) => {
                        if (!mppt.panel) return total;
                        return total + mppt.parallel * mppt.series;
                    }, 0);
                }
                return total + qty;
            }, 0);
        }
    }
};
</script>
